import React from 'react';
import { Popup } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/popup.less';

export default Popup;
